import { configureStore } from "@reduxjs/toolkit";
import buSlice from "../slices/BUSlice";
import CompanySlice from "../slices/CompanySlice";
import CompetitionIntensitySlice from "../slices/CompetitionIntensitySlice";
import ContractTypeSlice from "../slices/ContractTypeSlice";
import CSGOSlice from "../slices/CSGOSlice";
import CustomerSlice from "../slices/CustomerSlice";
import CustomerTypeSlice from "../slices/CustomerTypeSlice";
import CustomerTypeSPSlice from "../slices/CustomerTypeSPSlice";
import FilterSlice from "../slices/FilterSlice";
import FinanceSlice from "../slices/FinanceSlice";
import GeographySlice from "../slices/GeographySlice";
import ProjectCommentSlice from "../slices/ProjectCommentSlice";
import ProjectSlice from "../slices/ProjectSlice";
import ProjectSPSlice from "../slices/ProjectSPSlice";
import RoleSlice from "../slices/RoleSlice";
import sbgSlice from "../slices/SBGSlice";
import SBUSlice from "../slices/SBUSlice";
import SegmentClassificationSlice from "../slices/SegmentClassificationSlice";
import SegmentClassSPSlice from "../slices/SegmentClassSPSlice";
import SegmentLOBSlice from "../slices/SegmentLOBSlice";
import ShowProjectSlice from "../slices/ShowProjectSlice";
import TenderingBandwidthSlice from "../slices/TenderingBandwidthSlice";
import UserSlice from "../slices/UserSlice";
import BidCreationDocumentsSlice from "../slices/BidCreationDocumentsSlice";
import ProjectResponseSlice from "../slices/ProjectResponseSlice";
import ProjectStatusCountSlice from "../slices/ProjectStatusCountSlice";
import ProjectDocumentSlice from "../slices/ProjectDocumentSlice";
import ProjectStatusSlice from "../slices/ProjectStatusSlice";
import GetUserNameSlice from "../slices/GetUserNamesSlice";
import DashboardDetailsSlice from "../slices/DashboardDetailsSlice";
import ToastSlice from "../slices/ToastSlice";
import ProjectNotificationSlice from "../slices/ProjectNotificationSlice";
import CountrySlice from "../slices/CountrySlice";
import StateSlice from "../slices/StateSlice";
import WPFSlice from "../slices/WinProbabilityFactorSlice";
import CustomerGreenClassificationSlice from "../slices/CustomerGreenClassificationSlice";
import SegmentClassificationMapSlice from "../slices/SegmentClassificationMapSlice";
import SBUBUMapSlice from "../slices/SBUBUMapSlice";
import SegmentBUMapSlice from "../slices/SegmentBUMapSlice";
import UserHierarchySlice from "../slices/UserHierarchySlice";
import WinLossSlice from "../slices/WinLossSlice";
import BidderDetailSlice from "../slices/BidderDetailSlice";
import ProjectCompetitorsSlice from "../slices/ProjectCompetitorsSlice";
import CustomerPOCSlice from "../slices/CustomerPOCSlice";
import WaterfallDetailsSlice from "../slices/WaterfallDetailsSlice";

const store = configureStore({
  reducer: {
    user: UserSlice.reducer,
    sbg: sbgSlice.reducer,
    bu: buSlice.reducer,
    company: CompanySlice.reducer,
    competitionIntensity: CompetitionIntensitySlice.reducer,
    contractType: ContractTypeSlice.reducer,
    csgo: CSGOSlice.reducer,
    customer: CustomerSlice.reducer,
    customerType: CustomerTypeSlice.reducer,
    filter: FilterSlice.reducer,
    finance: FinanceSlice.reducer,
    geography: GeographySlice.reducer,
    role: RoleSlice.reducer,
    sbu: SBUSlice.reducer,
    segmentClassification: SegmentClassificationSlice.reducer,
    segmentLOB: SegmentLOBSlice.reducer,
    project: ProjectSlice.reducer,
    showProject: ShowProjectSlice.reducer,
    projectSP: ProjectSPSlice.reducer,
    tenderingBandwidth: TenderingBandwidthSlice.reducer,
    customerTypeSP: CustomerTypeSPSlice.reducer,
    segmentClassSP: SegmentClassSPSlice.reducer,
    projectComments: ProjectCommentSlice.reducer,
    bidCreationDocs: BidCreationDocumentsSlice.reducer,
    projectResponse: ProjectResponseSlice.reducer,
    projectStatusCount: ProjectStatusCountSlice.reducer,
    projectDocuments: ProjectDocumentSlice.reducer,
    projectStatus: ProjectStatusSlice.reducer,
    getUserName: GetUserNameSlice.reducer,
    dashboardDetails: DashboardDetailsSlice.reducer,
    toast: ToastSlice.reducer,
    projectNotifications: ProjectNotificationSlice.reducer,
    country: CountrySlice.reducer,
    state: StateSlice.reducer,
    wpf: WPFSlice.reducer,
    customerGreenClassifications: CustomerGreenClassificationSlice.reducer,
    segmentClassificationMap: SegmentClassificationMapSlice.reducer,
    SBUBUMapMap: SBUBUMapSlice.reducer,
    SegmentBUMap: SegmentBUMapSlice.reducer,
    UserHierarchy: UserHierarchySlice.reducer,
    winloss: WinLossSlice.reducer,
    bidderDetails: BidderDetailSlice.reducer,
    projectCompetitors: ProjectCompetitorsSlice.reducer,
    projectCustomerPOCs: CustomerPOCSlice.reducer,
    waterfallDetails: WaterfallDetailsSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
